import { connect } from 'react-redux'
import {
  dynamicLoadInstallers,
  createNewInstaller,
  resetCreateInstallerStatusMessages,
  setAvailableInstallers,
  setAvailableVendors,
  setInstallers,
  types,
} from '../../../../actions/projects/form_actions'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.CREATE_NEW_INSTALLER])

export default connect(
  (state: any) => ({
    createInstallerError: state.projects?.form?.createInstaller?.error,
    createInstallerSuccess: state.projects?.form?.createInstaller?.success,
    availableInstallers: state.projects?.form?.availableInstallers || [],
    availableVendors: state.projects?.form?.availableVendors || [],
    installers: state.projects?.form?.installers || [],
    isFetching: loadingSelector(state),
    vendors: state.projects?.form?.vendors || [],
  }),
  {
    createNewInstaller,
    resetCreateInstallerStatusMessages,
    setAvailableInstallers,
    setInstallers,
    setAvailableVendors,
    dynamicLoadInstallers,
  }
)
